import React, { FC, useState } from 'react'
import { Helmet } from 'react-helmet'

import Banners from '@ads/front-core/components/Banners'
import { lng } from '@ads/front-core/locales'
import Header from 'components/LandingpageHeader'
import Footer from 'components/views/Index/Footer'
import Body from 'components/views/Index/Body'

const Index: FC = () => {
  const [activeMenu, setActiveMenu] = useState<string>()

  return (
    <>
      <Helmet>
        <title>{lng('common:titlePage')}</title>
        <meta name="description" content={lng('common:descriptionPage')} />
        <meta
          property="og:description"
          content="WP Ads, e-commerce, marketplace, roas, kampania, display, mailing, reklama"
        />
      </Helmet>
      <Banners />
      <Header activeMenu={activeMenu} />
      <Body setActiveMenu={setActiveMenu} />
      <Footer />
    </>
  )
}

export default Index
